import { Grid, Typography } from "@material-ui/core";

import MeditocInfoField from "../../../utils/MeditocInfoField";
import MeditocModal from "../../../utils/MeditocModal";
import { useColaborador } from "../../../../context/ColaboradorContext";

export default function ReenviarCredenciales() {
    const {
        colaboradorSeleccionado,
        modalOpenReenviarCredenciales,
        handleOpenReenviarCredenciales,
        handleSubmitReenviarCredenciales,
    } = useColaborador();

    return (
        <MeditocModal
            title="Reenviar credenciales"
            open={modalOpenReenviarCredenciales}
            setopen={handleOpenReenviarCredenciales}
            okfunc={handleSubmitReenviarCredenciales}
            align="center"
            size="small"
        >
            <Grid container spacing={1} className="center">
                <Grid item xs={12}>
                    <Typography paragraph>
                        ¿Desea reenviar las credenciales de las cuentas asociadas al colaborador?
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography paragraph>
                        <MeditocInfoField label="Correo registrado:" value={colaboradorSeleccionado.sCorreoDoctor} />
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography>Cuentas asociadas:</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography paragraph>
                        <MeditocInfoField label="Titular:" value={colaboradorSeleccionado.sUsuarioTitular} />
                        {colaboradorSeleccionado.sUsuarioAdministrativo && (
                            <MeditocInfoField
                                label="Administrativa:"
                                value={colaboradorSeleccionado.sUsuarioAdministrativo}
                            />
                        )}
                    </Typography>
                </Grid>
            </Grid>
        </MeditocModal>
    );
}
